import { cn } from '@lib/cn'
import { PropsWithChildren } from 'react'

type ContainerProps = PropsWithChildren<
  {
    as?: React.ElementType
    variant?: 'stretch' | 'medium' | 'narrow'
  } & React.HTMLAttributes<HTMLElement>
>

const variantStyles = {
  stretch: 'max-w-[109rem]',
  medium: 'max-w-7xl',
  narrow: 'max-w-4xl',
}

export function Container({
  as = 'section',
  children,
  className,
  variant = 'stretch',
  ...props
}: ContainerProps) {
  const Component = as

  return (
    <Component
      {...props}
      className={cn(
        'container mx-auto w-[calc(100vw-2rem)] md:w-[calc(100vw-3rem)] xl:w-[calc(100vw-5.5rem)]',
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </Component>
  )
}
